import {VGLawCookie} from "vglawcookie";

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedHeader($(window));
		Vegas.fixedScrollTo($(window));
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		// navigation
		new VGNav({
			expand: 'lg'
		});

		// Nice Select
		$('.nice-select').niceSelect();

		// Tooltip
		$('.tooltip').niceSelect();

		// Twentytwenty
		let $twentytwenty = $('.vg-beforeAfter');
		if ($twentytwenty.length) {
			$twentytwenty.twentytwenty({
				before_label: 'До', // Set a custom before label
				after_label: 'После', // Set a custom after label
			});
		}

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		//$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');

		//
		let $individualSizes = $('[data-toggle="individual"]');
		if ($individualSizes.length) {
			$individualSizes.on('click', function () {
				let $self = $(this),
					$formSeries = $('#form-individual-sizes'),
					series = $self.text();

				$self.closest('.list-series').find('.btn--primary').removeClass('btn--primary').addClass('btn--outline-primary');
				$self.removeClass('btn--outline-primary').addClass('btn--primary');

				$formSeries.find('[data-individual="series"]').val(series);

				return false;
			});
		}
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-header-wrapper'),
			scroll = $self.scrollTop(),
			offset = $('header').height(),
			$body = $('body');

		if (scroll > offset) {
			$sticky.addClass('is-fixed');
			$body.addClass('vg-header-scroll');
		} else {
			$sticky.removeClass('is-fixed');
			$body.removeClass('vg-header-scroll');
		}
	}
};
